import React from 'react';
import { useState, useEffect, useCallback } from "react";
import { getBranches, getAddons, updateAddonsById, createAddonApi } from "../api/reusableApis";
import Notification from "../components/Notification";
import {
  FiPlus,
  FiSearch,
  FiEye,
  FiEdit2, FiMoreHorizontal
} from "react-icons/fi";
import Popover from "../components/ui/Popover";
import Modal from "../components/modal";

const Addons = () => {

  const [loader, setLoader] = useState(true);
  const [branch, setBranch] = useState([]);
  const [addons, setAddons] = useState([]);
  const [toast, setToast] = useState({ message: "", type: "success" });
  const [search, setSearch] = useState("");
  const [selectedBranch, setSelectedBranch] = useState();
  const [openMenuId, setOpenMenuId] = useState(null);
  const [menuPosition, setMenuPosition] = useState({ top: 0, left: 0 });
  const [openModal, setOpenModal] = useState(false);
  const [mode, setMode] = useState("create");
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    branches: []
  });
  const [selectedAddon, setSelectedAddon] = useState(null);
  const [form, setForm] = useState({});
  const [deletedImages, setDeletedImages] = useState([]);

  const fetchAllAddons = useCallback(async (selectedBranch) => {
    try {
      setLoader(true);
      console.log(selectedBranch, 'selectedBranch');
      const addons = await getAddons(selectedBranch);
      setAddons(addons);
      setLoader(false);
      console.log(addons, 'addons');
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }, []);

  const fetchBranch = useCallback(async () => {
    try {
      setLoader(true);
      const branches = await getBranches(true);
      setBranch(branches);
      setLoader(false);
      console.log(branches, 'branches');
      if (branches && branches.length > 0) {
        const firstBranchId = branches[0]['ROWID'];
        setSelectedBranch(firstBranchId);
        fetchAllAddons(firstBranchId);
      }
    } catch (error) {
      console.error(error);
      setLoader(false);
    }
  }, [fetchAllAddons]);

  // Filter addons based on search term
  const filteredAddons = addons.filter((addon) =>
    addon.name.toLowerCase().includes(search.toLowerCase()) ||
    addon.description.toLowerCase().includes(search.toLowerCase())
  );

  useEffect(() => {
    fetchBranch();
  }, []);

  function createAddons() {
    setMode("create");
    setFormData({
      name: "",
      description: "",
      branches: []
    });
    setForm({});
    setOpenModal(true);
  }

  function onBranchSelected(branch_id) {
    setSelectedBranch(branch_id);
    fetchAllAddons(branch_id);
  }

  function fetchBranchName(branch_id) {
    const branchDetails = branch.filter(data => data.ROWID === branch_id);
    return branchDetails?.[0]?.['name'];
  }

  const toggleMenu = (id) => {
    setOpenMenuId(openMenuId === id ? null : id);
  };

  const closeModal = () => {
    setOpenModal(false);
    setErrors({});
    setSelectedAddon({})
    setMode("");
  };

  const updateAddons = async () => {
    if (mode === 'edit') {
      console.log(form, 'form');
      console.log(formData, 'formdata');
      if (formData.name.length === 0) {
        setToast({
          message: "Addon's name is required.",
          type: "error",
        });
        return;
      }
      if (formData.description.length === 0) {
        setToast({
          message: "Addon's description is required.",
          type: "error",
        });
        return;

      }
      if (formData.branches.length === 0) {
        setToast({
          message: "Atleast one branch pricing is required",
          type: "error",
        });
        return;
      }

      let formDatas = new FormData();
      if (form.image) {
        formDatas.append('addon_image', form.image);
      }
      let requestObj = {};
      requestObj.description = formData.description;
      requestObj.name = formData.name;
      if (formData.branches.length > 0) {
        requestObj.branch_prices = formData.branches;
      }
      if (deletedImages && deletedImages.length > 0) {
        requestObj.delete_image_ids = deletedImages;
      }
      formDatas.append('json', JSON.stringify(requestObj));
      try {
        const response = await updateAddonsById(formDatas, selectedAddon.ROWID);
        console.log('Updated:', response.data);
        if (response.data.success === true) {
          setToast({
            message: response.data.message || "Addon's details updated successfully",
            type: "success",
          });
          fetchAllAddons(selectedBranch);
        } else if (response.data.success === false) {
          setToast({
            message: response.data?.message || "Failed to update the Addon's",
            type: "error",
          });
        }
        closeModal();
      } catch (error) {
        console.error('Update failed:', error);
        setToast({
          message: error?.message || "Something Went Wrong.!",
          type: "error",
        });
      }
    } else if (mode === 'create') {
      console.log(form, 'form');
      console.log(formData, 'formdata');
      if (formData.name.trim().length === 0) {
        setToast({
          message: "Addon's name is required.",
          type: "error",
        });
        return;
      }
      if (formData.description.trim().length === 0) {
        setToast({
          message: "Addon's description is required.",
          type: "error",
        });
        return;

      }
      if (formData.branches.length === 0) {
        setToast({
          message: "Atleast one branch pricing is required",
          type: "error",
        });
        return;
      }

      let formDatas = new FormData();
      if (form.image) {
        formDatas.append('addon_image', form.image);
      }
      let requestObj = {};
      requestObj.description = formData.description;
      requestObj.name = formData.name;
      if (formData.branches.length > 0) {
        requestObj.branch_prices = formData.branches;
      }
      formDatas.append('json', JSON.stringify(requestObj));
      try {
        const response = await createAddonApi(formDatas);
        console.log('created:', response.data);
        if (response.data.success === true) {
          setToast({
            message: response.data.message || "Addon's details created successfully",
            type: "success",
          });
          fetchAllAddons(selectedBranch);
        } else if (response.data.success === false) {
          setToast({
            message: response.data?.message || "Failed to create the Addon's",
            type: "error",
          });
        }
        closeModal();
      } catch (error) {
        console.error('Update failed:', error);
        setToast({
          message: error?.message || "Something Went Wrong.!",
          type: "error",
        });
      }
    }
  }

  const handleEdit = (addon) => {
    setSelectedAddon(addon);  // Set the full addon object
    setMode('edit');

    let obj = {
      logo: addon['images'].length > 0 ? addon['images'][0]['url'] : '',
      image: null,
      ROWID: addon['images'].length > 0 ? addon['images'][0]['ROWID'] : ''
    }
    console.log(obj);
    setForm(obj);
    setOpenModal(true);

  };

  const handleView = (addon) => {
    setSelectedAddon(addon);  // Set the full addon object
    setMode('view');
    let obj = {
      logo: addon['images'].length > 0 ? addon['images'][0]['url'] : '',
      image: null,
      ROWID: addon['images'].length > 0 ? addon['images'][0]['ROWID'] : ''
    }
    console.log(obj);
    setForm(obj);
    setOpenModal(true);
  };

  useEffect(() => {
    if ((mode === "edit" || mode === "view") && selectedAddon) {
      setFormData({
        name: selectedAddon.name || '',
        description: selectedAddon.description || '',
        branches: selectedAddon.branches || []
      });
    } else if (mode === "create") {
      setFormData({
        name: '',
        description: '',
        branches: []
      });
    }
  }, [mode, selectedAddon]);


  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      console.log(form, 'old form');
      let rowid = form?.ROWID || '';
      console.log(rowid, 'gowty');
      if (rowid.length > 0) {
        setDeletedImages([rowid]);
      }
      const logo = URL.createObjectURL(file); // preview
      setForm(prev => ({ ...prev, image: file, logo: logo, ROWID: "" }));
    }
  };

  return (
    <>
      {loader ? (
        <div className="flex items-center justify-center min-h-[60vh] w-full">
          <div className="w-8 h-8 border-4 border-gray-300 border-t-[#72398E] rounded-full animate-spin"></div>
        </div>
      )
        :
        <>
          <Notification
            message={toast.message}
            type={toast.type}
            onClose={() => setToast({ message: "", type: "success" })}
          />

          <div className="flex-1 px-4 sm:px-6 py-6 pt-20 lg:pt-6 bg-gradient-to-br from-slate-50 via-white to-slate-100 min-h-screen w-full
">
            <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8">
              <div>
                <h1 className="text-3xl font-bold tracking-tight text-[#72398E]">Addon's</h1>
                <p className="text-sm text-slate-500">
                  Manage addon's, define the addon's price with branch wise with ease.
                </p>
              </div>

              <div className="flex gap-3 w-full sm:w-auto">
                <button
                  onClick={() => createAddons()}
                  className="flex items-center gap-2 text-white px-5 py-2 rounded-xl shadow-md transition bg-[#72398E]"
                >
                  <FiPlus /> Addon's
                </button>
              </div>
            </div>

            <div className="bg-white rounded-xl border border-slate-200 p-4 flex flex-col sm:flex-row gap-4 mb-6">
              <div className="flex items-center gap-2 border border-slate-300 rounded-xl px-4 py-2 flex-1 bg-slate-50 focus-within:ring-2 focus-within:ring-slate-900">
                <FiSearch className="text-slate-400" />
                <input
                  placeholder="Search Addon names"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                  className="bg-transparent outline-none text-sm w-full"
                />
              </div>

              <select
                value={selectedBranch}
                onChange={(e) => onBranchSelected(e.target.value)}
                className="h-10 px-4 rounded-xl border border-slate-300 bg-slate-50 text-sm"
              >
                {branch.map((r) => (
                  <option key={r.ROWID} value={r.ROWID}>{r.name}</option>
                ))}
              </select>
            </div>


            <div className="hidden md:block bg-white rounded-xl shadow-sm overflow-hidden max-h-[60vh] overflow-y-auto">
              <table className="w-full text-sm">
                <thead className="bg-slate-100 text-slate-500 uppercase text-xs tracking-wider">
                  <tr>
                    <th className="p-4 text-left">Addon's Name</th>
                    <th className="text-center">Status</th>
                    <th className="text-center">Description</th>
                    <th className="text-center">Branch</th>
                    <th className="text-center">Price</th>
                    <th className="text-right pr-6">Actions</th>
                  </tr>
                </thead>
                <tbody className="divide-y">
                  {filteredAddons && filteredAddons.length > 0 ? filteredAddons.map((addon) => (
                    <tr key={addon.ROWID} className="hover:bg-slate-50 transition">
                      <td className="flex items-center gap-3 p-4">
                        <img
                          src={addon.images?.length > 0 ? addon.images[0]?.url : filteredAddons}
                          className="w-10 h-10 rounded-xl ring-2 ring-white shadow"
                        />
                        <div>
                          <p className="font-semibold">
                            {addon.name}
                          </p>
                        </div>
                      </td>
                      <td className="text-center">
                        <span
                          className={`px-3 py-1 rounded-full text-xs font-semibold ${addon.branches?.[0].is_active === true
                            ? "bg-purple-100 text-purple-700"
                            : "bg-rose-100 text-rose-600"
                            }`} >
                          {addon.branches?.[0].is_active === true ? "Active" : "In-Active"}
                        </span>
                      </td>
                      <td className="text-center text-slate-600 min-w-[80px] max-w-[200px]">{addon.description}</td>
                      <td className="text-center text-slate-600">{fetchBranchName(addon.branches?.[0]['branch_id'])}</td>
                      <td className="text-center text-slate-600"> ₹ {addon.branches?.[0]['price']}</td>
                      <td className="text-center relative">
                        <Popover
                          placement="bottom-end"
                          trigger={
                            <FiMoreHorizontal onClick={(e) => {
                              const rect = e.currentTarget.getBoundingClientRect();
                              setMenuPosition({
                                top: rect.bottom + 4,
                                left: rect.right - 160,
                              });
                              toggleMenu(addon.ROWID);
                            }} className="cursor-pointer text-slate-500 hover:text-slate-800" />
                          }
                        >
                          <button onClick={() => handleView(addon)} className="flex items-center gap-2 w-full px-4 py-2 text-sm hover:bg-slate-100">
                            <FiEye /> View
                          </button>

                          <button onClick={() => handleEdit(addon)} className="flex items-center gap-2 w-full px-4 py-2 text-sm hover:bg-slate-100" >
                            <FiEdit2 /> Edit
                          </button>

                        </Popover>
                      </td>
                    </tr>
                  ))
                    :
                    <tr>
                      <td colSpan={6} className="py-12 px-4">
                        <div className="flex flex-col items-center justify-center text-center text-gray-500 py-8">
                          <div className="w-16 h-16 mx-auto mb-4 bg-gray-100 rounded-2xl flex items-center justify-center">
                            <span className="text-2xl text-gray-400">📦</span>
                          </div>
                          <h3 className="text-lg font-semibold text-gray-900 mb-1">No Addons Found</h3>
                          <p className="text-sm text-gray-500">No addons available for this branch</p>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>

            <div className="md:hidden space-y-4">
              {filteredAddons.length === 0 ? (
                <div className="text-center text-slate-400 py-10">
                  No Addon's found
                </div>
              ) : (
                filteredAddons.map((addon) => (
                  <div
                    key={addon.ROWID}
                    className="bg-white rounded-2xl p-4 shadow-sm border border-slate-200 hover:shadow-lg transition-shadow duration-200"
                  >
                    {/* Top Section with Actions aligned */}
                    <div className="flex items-center justify-between gap-4">
                      {/* User Info */}
                      <div className="flex items-center gap-4 min-w-0">
                        <img
                          src={addon.images?.length > 0 ? addon.images[0]?.url : addons}
                          alt={`${addon.name}`}
                          className="w-14 h-14 rounded-xl ring-2 ring-white shadow"
                        />

                        <div className="flex-1 min-w-0">
                          <p className="font-semibold text-slate-900 truncate">
                            {addon.name}
                          </p>
                          <p className="text-sm text-slate-500 truncate">{addon.description}</p>

                          <div className="flex items-center gap-2 mt-1">
                            <span
                              className={`inline-block px-3 py-1 rounded-full text-xs font-semibold ${addon.branches?.[0].is_active === true
                                ? "bg-purple-100 text-purple-700"
                                : "bg-rose-100 text-rose-600"
                                }`}
                            >
                              {addon.branches?.[0].is_active === true ? "Active" : "In-Active"}
                            </span>

                            <span className="text-purple-700 text-xs font-semibold">₹ {addon.branches?.[0]['price']}</span>
                          </div>
                        </div>
                      </div>

                      {/* Actions Icon aligned to top row */}
                      <Popover
                        placement="bottom-end"
                        trigger={
                          <FiMoreHorizontal className="cursor-pointer text-slate-500 hover:text-slate-800" />
                        }
                      >
                        <button
                          onClick={() => handleView(addon)}
                          className="flex items-center gap-2 w-full px-4 py-2 text-sm hover:bg-slate-100"
                        >
                          <FiEye /> View
                        </button>

                        <button
                          onClick={() => handleEdit(addon)}
                          className="flex items-center gap-2 w-full px-4 py-2 text-sm hover:bg-slate-100"
                        >
                          <FiEdit2 /> Edit
                        </button>
                      </Popover>
                    </div>
                  </div>
                ))
              )}
            </div>

          </div>


          {/* ---------- Modal ---------- */}
          <Modal
            open={openModal}
            onClose={closeModal}
            title={
              mode === "view"
                ? "View Addon's"
                : mode === "edit"
                  ? "Edit Addon's"
                  : "Create Addon's"
            }
            width="w-full sm:w-[95%] md:max-w-2xl" // Increased width for better 2-column layout
          >
            <div className="space-y-8 p-1">
              <Notification
                message={toast.message}
                type={toast.type}
                onClose={() => setToast({ message: "", type: "success" })}
              />
              {(mode === "create" || mode === "edit" || mode === 'view') && (
                <div className="mb-8 flex flex-col items-center sm:flex-row gap-6 p-5 rounded-2xl bg-slate-50 border border-dashed border-slate-200">
                  <div className="relative group">
                    <div className="h-24 w-24 rounded-2xl overflow-hidden bg-slate-200 ring-4 ring-white shadow-md">
                      {form.logo ? (
                        <img src={form.logo} alt="Preview" className="h-full w-full object-cover" />
                      ) : (
                        <div className="h-full w-full flex items-center justify-center text-slate-400 text-xs text-center p-2 font-medium">
                          No Logo
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex-1 text-center sm:text-left">
                    <h4 className="text-sm font-bold text-slate-700">Addon's Identity</h4>
                    <p className="text-xs text-slate-500 mb-3">Upload a high-quality logo (PNG, JPG)</p>
                    <input
                      type="file"
                      accept="image/*"
                      onChange={handleImageUpload}
                      className="hidden"
                      id="logo-upload"
                      disabled={mode === 'view'}
                    />
                    <label
                      htmlFor="logo-upload"
                      className="inline-block px-4 py-2 bg-white border border-slate-200 rounded-lg text-xs font-bold text-slate-600 cursor-pointer hover:border-purple-500 hover:text-purple-600 transition-all shadow-sm"
                    >
                      Choose Image
                    </label>

                    {errors.image && (
                      <div className="text-[11px] text-rose-500 mt-2 font-medium">
                        {errors.image}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* --- Section 1: Basic Information --- */}
              <div>
                <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
                  <span className="w-8 h-[1px] bg-slate-200"></span> Addon Details
                </h3>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-5">
                  <FormInput
                    label="Addon Name"
                    value={formData.name}
                    onChange={(val) => {
                      setFormData((p) => ({ ...p, name: val }));
                      setErrors((prev) => ({ ...prev, name: null }));
                    }}
                    placeholder="Addon Name"
                    disabled={mode === "view"}
                    error={errors.name}
                  />

                  <FormInput
                    label="Description"
                    value={formData.description}
                    onChange={(val) => {
                      setFormData((p) => ({ ...p, description: val }));
                      setErrors((prev) => ({ ...prev, description: null }));
                    }}
                    placeholder="Description"
                    disabled={mode === "view"}
                    error={errors.description}
                  />


                </div>
              </div>

              <div>
                <h3 className="text-[10px] uppercase tracking-[0.15em] font-black text-slate-400 mb-5 flex items-center gap-2">
                  <span className="w-8 h-[1px] bg-slate-200"></span> Branch wise Pricing
                </h3>

                <div className="space-y-4 max-h-96 overflow-y-auto">
                  {formData.branches?.map((branchPrice, index) => (
                    <div key={index}>
                      <div className="flex items-end gap-4 p-4 bg-slate-50 rounded-xl group hover:bg-slate-100 transition-all">
                        {/* Branch Dropdown */}
                        <div className="flex-1">
                          <label className="block text-xs font-semibold text-slate-600 mb-1">
                            Branch
                          </label>
                          <select
                            value={branchPrice.branch_id || ''}
                            onChange={(e) => {
                              setFormData(prev => ({
                                ...prev,
                                branches: prev.branches.map((b, i) =>
                                  i === index ? { ...b, branch_id: e.target.value } : b
                                )
                              }));
                            }}
                            className="w-full px-3 py-2 border border-slate-200 rounded-lg bg-white text-sm"
                            disabled={mode === "view" } //|| mode === "edit"
                          >
                            <option value="">Select Branch</option>
                            {branch
                              .filter(b =>
                                !formData.branches.some((existing, i) =>
                                  existing.branch_id === b.ROWID && i !== index  // ✅ Exclude OTHER rows only
                                )
                              )
                              .map(b => (
                                <option key={b.ROWID} value={b.ROWID}>{b.name}</option>
                              ))}
                          </select>
                        </div>

                        {/* Price Input */}
                        <div className="flex-1">
                          <label className="block text-xs font-semibold text-slate-600 mb-1">
                            Price (₹)
                          </label>
                          <input
                            type="number"
                            value={branchPrice.price || ''}
                            onChange={(e) => {
                              const price = e.target.value;
                              setFormData(prev => ({
                                ...prev,
                                branches: prev.branches.map((b, i) =>
                                  i === index ? { ...b, price } : b
                                )
                              }));
                            }}
                            placeholder="0"
                            min="0"
                            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-sm"
                            disabled={mode === "view"}
                          />
                        </div>

                        {/* Remove Row */}
                        {formData.branches.length > 1 && mode !== "view" && (
                          <button
                            type="button"
                            onClick={() => {
                              setFormData(prev => ({
                                ...prev,
                                branches: prev.branches.filter((_, i) => i !== index)
                              }));
                            }}
                            className="p-2 -m-2 text-red-500 hover:text-red-700 hover:bg-red-50 rounded-lg transition-all group-hover:opacity-100 opacity-0"
                            title="Remove"
                          >
                            ×
                          </button>
                        )}
                      </div>

                      <div className="flex items-center justify-between p-5 mt-5 rounded-2xl bg-slate-50 border border-slate-100 transition-all hover:bg-slate-100/50">
                        <div>
                          <p className="text-sm font-bold text-slate-700">Active Status</p>
                          <p className="text-xs text-slate-500">Visible to customers and staff</p>
                        </div>
                        <label className="relative inline-flex items-center cursor-pointer">
                          <input
                            type="checkbox"
                            checked={branchPrice.is_active ?? true}  // ✅ Default false
                            onChange={(e) => {
                              setFormData(prev => ({
                                ...prev,
                                branches: prev.branches.map((branch, i) =>
                                  i === index
                                    ? { ...branch, is_active: e.target.checked }
                                    : branch
                                )
                              }));
                            }}
                            className="sr-only peer"
                            disabled={mode === "view"}
                          />
                          <div className="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-purple-600"></div>
                        </label>
                      </div>
                    </div>
                  )) || (
                      <div className="text-center py-8 text-gray-500">
                        No branches selected
                      </div>
                    )}
                </div>



                {/* Add Branch Row Button */}
                {mode !== "view"  && (
                  <button
                    type="button"
                    onClick={() => {
                      setFormData(prev => ({
                        ...prev,
                        branches: [...(prev.branches || []), { branch_id: '', price: '' }]
                      }));
                    }}
                    className="w-full flex items-center justify-center gap-2 px-4 py-3 mt-4 border-2 border-dashed border-slate-300 rounded-xl hover:border-blue-400 hover:bg-blue-50 transition-all text-sm font-medium text-slate-600 hover:text-blue-600"
                  >
                    ➕ Add Branch Price
                  </button>
                )}

              </div>

              {/* --- Action Buttons --- */}
              <div className="flex justify-end gap-3 pt-6 border-t border-slate-100">
                <button
                  onClick={closeModal}
                  className="px-6 py-2.5 rounded-xl text-sm font-bold text-slate-500 hover:bg-slate-100 transition-colors"
                >
                  Discard
                </button>

                {mode !== "view" && (
                  <button
                    onClick={updateAddons}
                    className="px-8 py-2.5 rounded-xl bg-[#72398E] text-white text-sm font-bold shadow-lg shadow-slate-200 hover:bg-purple-600 transition-all active:scale-95"
                  >
                    {mode === "edit" ? "Save Changes" : "Save"}
                  </button>
                )}
              </div>
            </div>
          </Modal>
        </>
      }
    </>
  )
}

function FormInput({
  label,
  value,
  onChange,
  placeholder,
  readOnly,
  disabled,
  type = "text",
  error
}) {
  return (
    <div className="flex flex-col">
      <label className="text-xs font-bold text-slate-600 mb-1.5 ml-1 uppercase tracking-wider">
        {label}
      </label>
      <input
        type={type}
        placeholder={placeholder}
        value={value || ""}
        readOnly={readOnly}
        disabled={disabled}   // ✅ apply it here
        onChange={(e) => onChange(e.target.value)}
        className={`w-full border rounded-xl px-4 py-2.5 text-sm transition-all outline-none 
          ${error ? 'border-rose-400 focus:ring-rose-500/20' : 'border-slate-200 focus:ring-purple-500/10'}
          ${(readOnly || disabled)
            ? 'bg-slate-50 text-slate-400 cursor-not-allowed'
            : 'hover:border-slate-300 focus:ring-4 focus:border-purple-500'}
        `}
      />
      {error && (
        <span className="text-[11px] text-rose-500 mt-1 ml-1 font-medium italic">
          {error}
        </span>
      )}
    </div>
  );
}

export default Addons